import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function createImage(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_image = userData;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_IMAGES_REQUESTED", "CREATE_IMAGES_SUCCESS", "CREATE_IMAGES_FAILED"],
        method: "POST",
        path: "admin/create_image",
        body: data
    });
}

export function getImages() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_IMAGES_REQUESTED", "GET_IMAGES_SUCCESS", "GET_IMAGES_FAILED"],
        method: "POST",
        path: "admin/get_images",
        body: data
    });
}

export function updateImages(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_image = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_IMAGES_REQUESTED", "UPDATE_IMAGES_SUCCESS", "UPDATE_IMAGES_FAILED"],
        method: "POST",
        path: "admin/update_image",
        body: data
    });
}

export function setImagesPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_IMAGES_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteImages(imageId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_image = {"image_id": imageId};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_IMAGES_REQUESTED", "DELETE_IMAGES_SUCCESS", "DELETE_IMAGES_FAILED"],
        method: "POST",
        path: "admin/delete_image",
        body: data
    });
}

export function getServerCustomNetworkNames() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SERVER_CUSTOM_NETWORK_REQUESTED", "GET_SERVER_CUSTOM_NETWORK_SUCCESS", "GET_SERVER_CUSTOM_NETWORK_FAILED"],
        method: "POST",
        path: "admin/get_server_custom_network_names",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionImage.js